import React from 'react';

const Footer = () => {
  return (
    <footer className='bg-dark'>
      <p className='text-white'> Powered by Cryptoday. INC</p>
      <p className='text-white'> Created by Mahmoud Ahmed. © 2020</p>
    </footer>
  );
};

export default Footer;
